import { filtersHelper } from '@/utils';

export const roleModel = (data = {}) => ({
    uuid: data.uuid, name: data.name || '', description: data.description || '',
    isActive: [true, 1, '1'].includes(data.is_active),
    createdAt: filtersHelper.getDateTimeFormat(data.created_at),
    // Retain dynamic numeric permission levels without response metadata.
    permissions: Object.fromEntries(Object.entries(data).filter(([key, value]) =>
        !['id', 'is_active'].includes(key) && (typeof value === 'number' || (typeof value === 'string' && /^\d+$/.test(value)))
    ).map(([key, value]) => [key, Number(value)])),
});
